/**
 * RESPONSIBILITY: name every section on this site. Nothing else.
 *
 * `cms.get()` and `<SectionUpdate name=…>` take this enum, so a typo is a compile
 * error rather than a blank space on the page at runtime.
 *
 * Three groups, and the split is deliberate:
 *
 *   chrome   on every page
 *   shared   one list, read by many pages — an event is entered once
 *   pages    a page's own words. Never a copy of anything above
 */
export enum SectionName {
  /* ---- chrome ---- */
  Theme = 'theme',
  Header = 'header',
  Footer = 'footer',
  Words = 'words',

  /* ---- shared ---- */
  Events = 'events',
  Sermons = 'sermons',
  Ministries = 'ministries',

  /* ---- pages: one band, one section, one pencil ---- */
  AboutHero = 'about_hero',
  AboutPurpose = 'about_purpose',
  AboutTenets = 'about_tenets',
  AboutFaith = 'about_faith',
  AboutStory = 'about_story',
  AboutAnniversary = 'about_anniversary',
  Bulletin = 'bulletin',
  AboutEstablished = 'about_established',
  VisitHero = 'visit_hero',
  VisitExpect = 'visit_expect',
  VisitCta = 'visit_cta',

  MinistriesHero = 'ministries_hero',
  MinistryPage = 'ministry_page',

  HomeHero = 'home_hero',
  HomeMission = 'home_mission',
  HomeEvents = 'home_events',
  HomeMinistries = 'home_ministries',
  HomeSermon = 'home_sermon',
  HomeGive = 'home_give',
  HomeVisit = 'home_visit',
  ChildrenHero = 'children_hero',
  ChildrenIntro = 'children_intro',
  ChildrenAges = 'children_ages',
  ChildrenFaq = 'children_faq',
  ChildrenTeam = 'children_team',
  ChildrenEvents = 'children_events',
  ChildrenCta = 'children_cta',
  AdcTop = 'adc_top',
  AdcBlocks = 'adc_blocks',
  AdcFoot = 'adc_foot',
  AdcTheme = 'adc_theme',
  Requests = 'requests',
  EventsHero = 'events_hero',
  SermonsHero = 'sermons_hero',
  SermonsArchive = 'sermons_archive',
  LeadershipHero = 'leadership_hero',
  LeadershipNote = 'leadership_note',
  LeadershipPillars = 'leadership_pillars',
  LeadershipTeam = 'leadership_team',
  LeadershipVisit = 'leadership_visit',
  Give = 'give',
  HouseOfHonor = 'house_of_honor',
  Contact = 'contact',
  Share = 'share',
}
